module.exports = __webpack_public_path__ + "img/concreto_para_castillos_ahogados.ef7033d7.png";